import {
  GetAdminOrganizationSummaryByIdPathParamsType,
  GetAdminOrganizationSummaryByIdResponseBodyType,
  GetOrganizationSummaryResponseBodyType,
} from "@intelligems/ig-types";
import { ApiRequest } from "@src/api/types/api";
import { useMutation } from "@tanstack/react-query";

import { api } from "../api";

export const getAdminOrganizationSummaryById = async (id: string) => {
  const resp = await api.get<GetAdminOrganizationSummaryByIdResponseBodyType>(
    `/v2/admin/organizations/${id}`
  );
  return resp.data;
};

export const useGetAdminOrganizationSummaryById = () => {
  return useMutation<
    GetOrganizationSummaryResponseBodyType,
    Error,
    ApiRequest<any, GetAdminOrganizationSummaryByIdPathParamsType>,
    any
  >({
    mutationFn: async (
      data: ApiRequest<any, GetAdminOrganizationSummaryByIdPathParamsType>
    ) => getAdminOrganizationSummaryById(data.pathParams.orgId),
  });
};
